module.exports = __webpack_public_path__ + "img/670-ec2b8d.png";